module.exports = __webpack_public_path__ + "static/media/U1-T2-2-2.49ac2410.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/U1-T2-2-2.mp3
// module id = 546
// module chunks = 0